import GenerateBody from "./GenerateBody";

export default GenerateBody;